// extracted by mini-css-extract-plugin
export default {"input":"TodoInput_input__L+r2I","borderRadius":"TodoInput_borderRadius__O4qnf"};